import { useEffect, useState } from 'react';
import { Smartphone } from 'lucide-react';
import { useTranslation } from '../i18n';

const isMobileViewport = () => {
  if (typeof window === 'undefined') return false;
  const coarse = window.matchMedia('(pointer: coarse)').matches;
  const small = window.matchMedia('(max-width: 900px)').matches;
  return coarse && small;
};

const isPortrait = () => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(orientation: portrait)').matches;
};

const RotateDeviceOverlay = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(() => isMobileViewport() && isPortrait());

  useEffect(() => {
    const update = () => setShow(isMobileViewport() && isPortrait());
    const portraitMq = window.matchMedia('(orientation: portrait)');
    const widthMq = window.matchMedia('(max-width: 900px)');

    portraitMq.addEventListener?.('change', update);
    widthMq.addEventListener?.('change', update);
    window.addEventListener('resize', update);

    return () => {
      portraitMq.removeEventListener?.('change', update);
      widthMq.removeEventListener?.('change', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center px-8 text-center"
      style={{ backgroundColor: '#2A4D25', color: 'white' }}
    >
      <div className="relative mb-8" style={{ width: 120, height: 120 }}>
        <Smartphone
          size={88}
          strokeWidth={1.5}
          className="absolute inset-0 m-auto"
          style={{
            animation: 'rotate-device-anim 2.2s ease-in-out infinite',
            transformOrigin: 'center',
          }}
        />
      </div>

      <h2 className="text-2xl font-semibold mb-3">{t('notifications.rotateDeviceTitle')}</h2>
      <p className="text-base opacity-90 max-w-xs leading-relaxed">
        {t('notifications.rotateDeviceMessage')}
      </p>

      <style>{`
        @keyframes rotate-device-anim {
          0%   { transform: rotate(0deg); }
          40%  { transform: rotate(0deg); }
          70%  { transform: rotate(-90deg); }
          100% { transform: rotate(-90deg); }
        }
      `}</style>
    </div>
  );
};

export default RotateDeviceOverlay;
